// Plan Reference -> Application Plan UUID (self-checkout + comercial)
export const CURSEDUCA_PLANS_REFERENCES: Record<string, string> = {
	// Self-checkout
	RXZvbHV0aW9uIFNlbGYtT25ib2FyZGluZ19YX3VuZGVmaW5lZF8xNzU0NTc3ODI1Nzc4:
		'9c148df41-82e2-4f8d-a7c7-ad07ef8ba4a5', // Evolution
	RXZvbHV0aW9uIEJsYWNrIEZyaWRheV9YX3VuZGVmaW5lZF8xNzYxMjQ2MDI2MjM3:
		'9c148df41-82e2-4f8d-a7c7-ad07ef8ba4a5', // Evolution Black Friday
		'RXZvbHV0aW9uIEFQUCBTZWxmY2hlY2tvdXRfWF91bmRlZmluZWRfMTc1Njk5NDYxNTUyMQ==':
		'9c148df41-82e2-4f8d-a7c7-ad07ef8ba4a1', // Evolution APP 
	'RXZvbHV0aW9uIEFQUCAzMCVfWF91bmRlZmluZWRfMTc4MTIwMzM0MjQzNA==':
		'9c148df41-82e2-4f8d-a7c7-ad07ef8ba4a1', // Evolution APP 30% OFF - Self-checkout
	'RXZvbHV0aW9uIEFQUCBTZWxmY2hlY2tvdXQgQmxhY2sgRnJpZGF5X1hfdW5kZWZpbmVkXzE3NjE5MTM4MjQ2OTE=':
		'9c148df41-82e2-4f8d-a7c7-ad07ef8ba4a1', // Evolution APP Black Friday
	'UHJvX1hfdW5kZWZpbmVkXzE3NzAzMDAyNDkzNTM=':
		'9c148df41-82e2-4f8d-a7c7-ad07ef8ba400', // Pro
	'QmxhY2tfWF91bmRlZmluZWRfMTc3MDMwMDI4OTUwMw==':
		'9c148df41-82e2-4f8d-a7c7-ad07ef8ba111', // Black
	'RXZvbHV0aW9uIDE1JSBPRkYgLSBTZWxmY2hlY2tvdXRfWF91bmRlZmluZWRfMTc3NzY0MTgxNDkwNQ==':
		'9c148df41-82e2-4f8d-a7c7-ad07ef8ba4a5', // Evolution 15% OFF - Self-checkout
	'RXZvbHV0aW9uIEFQUCAyNSUgT0ZGIC0gU2VsZmNoZWNrb3V0X1hfdW5kZWZpbmVkXzE3Nzc2NDE3MzAzOTA=':
		'9c148df41-82e2-4f8d-a7c7-ad07ef8ba4a1', // Evolution APP 25% OFF - Self-checkout
	'UHJvIDMzJSBPRkYgLSBTZWxmY2hlY2tvdXRfWF91bmRlZmluZWRfMTc3NzU3NjIwOTk3Ng==':
		'9c148df41-82e2-4f8d-a7c7-ad07ef8ba400', // Pro 33% OFF - Self-checkout
		// Comercial (sempre compartilhado com ?origin=COMERCIAL no link)
	IEV2b2x1dGlvbiAtIEFudWFsICBbQ29tZXJjaWFsXV9YX3VuZGVmaW5lZF8xNzc1ODQ0OTE3OTE3:
		'9c148df41-82e2-4f8d-a7c7-ad07ef8ba4a5', // Evolution - Anual [Comercial]
	'RXZvbHV0aW9uIEFQUCAtIEFudWFsIFtDb21lcmNpYWxdX1hfdW5kZWZpbmVkXzE3NzU4NDU2NDYxMDk=':
		'9c148df41-82e2-4f8d-a7c7-ad07ef8ba4a1', // Evolution APP - Anual [Comercial]
	'UHJvIC0gQW51YWwgW0NvbWVyY2lhbF1fWF91bmRlZmluZWRfMTc3NTg0NjI2NjU5Ng==':
		'9c148df41-82e2-4f8d-a7c7-ad07ef8ba400', // Pro - Anual [Comercial]
	QmxhY2sgLSBBbnVhbCBbQ29tZXJjaWFsXV9YX3VuZGVmaW5lZF8xNzc1ODQ2NTU3NDE1:
		'c1e1533e-1836-47b4-ab9f-a32cf9486a03', // Black - Anual [Comercial]
	'RXZvbHV0aW9uIC0gUmVjb3Jyw6puY2lhIFtDb21lcmNpYWxdX1hfdW5kZWZpbmVkXzE3NzU4NDY3Mzc1Mzc=':
		'9c148df41-82e2-4f8d-a7c7-ad07ef8ba4a5', // Evolution - Recorrência [Comercial]
	'RXZvbHV0aW9uIEFQUCAtIFJlY29ycmVudGUgW0NvbWVyY2lhbF1fWF91bmRlZmluZWRfMTc3NTg0NzIwMDEwMg==':
		'9c148df41-82e2-4f8d-a7c7-ad07ef8ba4a1', // Evolution APP - Recorrente [Comercial]
	'RXZvbHV0aW9uIEFQUCAyMCUgT0ZGX1hfdW5kZWZpbmVkXzE3ODczMTM5NTk0NDQ=':
	 '9c148df41-82e2-4f8d-a7c7-ad07ef8ba4a1', // Evolution APP 20% OFF - [Comercial]
	'UFJPIDIwJSBPRkYgLSBBbnVhbF9YX3VuZGVmaW5lZF8xNzg3MzE0MTEyOTYx':
	'9c148df41-82e2-4f8d-a7c7-ad07ef8ba400', // Pro 20% OFF - Anual [Comercial]
	'RXZvbHV0aW9uIEFQUCAyNSUgT0ZGIFtDb21lcmNpYWxdX1hfdW5kZWZpbmVkXzE3ODc1ODYzNjk1Mzc=':
		'9c148df41-82e2-4f8d-a7c7-ad07ef8ba4a1', // Evolution APP 25% OFF [Comercial]
	'UGxhbm8gUFJPIDI1JSBPRkYgW0NvbWVyY2lhbF1fWF91bmRlZmluZWRfMTc4NzU4NzY5MzU4Mw==':
		'9c148df41-82e2-4f8d-a7c7-ad07ef8ba400', // Plano PRO 25% OFF [Comercial]
	'RXZvbHV0aW9uIEFQUCAyOCUgT0ZGIFtDb21lcmNpYWxdX1hfdW5kZWZpbmVkXzE3ODc1ODc5NTQzMzk=':
		'9c148df41-82e2-4f8d-a7c7-ad07ef8ba4a1', // Evolution APP 28% OFF [Comercial]
	'UFJPIDI4JSBPRkYgW0NvbWVyY2lhbF1fWF91bmRlZmluZWRfMTc4NzU4ODI1Njc4MQ==':
		'9c148df41-82e2-4f8d-a7c7-ad07ef8ba400', // PRO 28% OFF [Comercial]
	'UFJPIDMwJSBPRkYgW0NvbWVyY2lhbF1fWF91bmRlZmluZWRfMTc4NzU4ODQzNzU2Mw==':
		'9c148df41-82e2-4f8d-a7c7-ad07ef8ba400', // PRO 30% OFF [Comercial]
	'RXZvbHV0aW9uIEFQUCAzMCUgT0ZGIFtDb21lcmNpYWxdX1hfdW5kZWZpbmVkXzE3ODc1ODg2NDU1MzI=':
		'9c148df41-82e2-4f8d-a7c7-ad07ef8ba4a1', // Evolution APP 30% OFF [Comercial]
	W1Rlc3RlIEVuZ2VuaGFyaWEgcmVjb3JyZW5jaWEgZGUgcGl4XV9YX3VuZGVmaW5lZF8xNzg3NTg4ODAxNzg3:
		'9c148df41-82e2-4f8d-a7c7-ad07ef8ba4a1', // [Teste Engenharia recorrencia de pix]
	'UFJPIDMwJSBPRkYgW0NvbWVyY2lhbF0gTWVuc2FsX1hfdW5kZWZpbmVkXzE3ODc1OTYwOTEzOTE=':
		'9c148df41-82e2-4f8d-a7c7-ad07ef8ba400', // PRO 30% OFF [Comercial] Mensal
	RXZvbHV0aW9uIEFQUCAzMCUgT0ZGIFtDb21lcmNpYWxdIE1lbnNhbF9YX3VuZGVmaW5lZF8xNzg3NTk2Mjg0MTI5:
		'9c148df41-82e2-4f8d-a7c7-ad07ef8ba4a1', // Evolution APP 30% OFF [Comercial] Mensal
};

// Plan Reference -> Application Plan UUID
export const CHAT_AI_PLANS_REFERENCES: Record<string, string> = {
	VGVzdGUgQ2hhdCBBSV9YX3VuZGVmaW5lZF8xNzQ3MzQ3Njk5NzI0:
		'58aab11a-31db-11f0-8e95-122383938381'
};
